export const PARTNER_WIDGET_DEFAULT_FEATURES = ['notitle', 'logo', 'nolistbutton', 'emptyDummy'] as const;

export interface PartnerWidgetRegistration {
  scriptUrl: string;
  scriptId: string;
  containerId: string;
  experienceData?: string;
}

/** Параметры виджета (из API/контента) */
export interface PartnerWidgetParams {
  city: string | null;
  region: string | null;
  country: string | null;
  currency: string;
  mode: string;
  url: string;
  erid_token: string;
  features?: string[];
  preContent?: boolean;
}

/** Элемент списка впечатлений в виджете */
export interface PartnerWidgetExperience {
  id: number;
  title: string;
  tagline: string;
  annotation: string;
  type: string;
  url: string;
  cover_image: string;
  rating: string;
  review_count: number;
  visitors_count: number;
  duration: number;
  is_paid: boolean;
  price: Record<string, unknown>;
  is_replacement: boolean;
}

/** Данные партнёрского виджета (формат из API) */
export interface PartnerWidgetData {
  widget_params: PartnerWidgetParams;
  experiences: PartnerWidgetExperience[];
}
